





















































































import { Component, Vue } from 'vue-property-decorator'
import { TableColumnItemType, OperationItemType, OptionItemType } from '../../types/type'
import { CanteenModule } from '../../store'
import { findItemForTree } from '../../utils/toolsForCommon'
@Component({
  name: 'FoodPriceManagement',
  components: {
    'my-table': () => import('../../components/common/myTable/index.vue'),
    'my-dialog': () => import('../../components/common/myDialog.vue')
  }
})
export default class FoodPriceManagement extends Vue {
  public paneName: string = 'foodPriceModule'
  // 食材价格管理相关：
  // 列表列有哪些：
  public foodPriceModuleTitleList: Array<TableColumnItemType> = [
    {
      title: '食材名称',
      key: 'name',
      flex: 1
    },
    {
      title: '市场价格区间',
      key: 'maxOrMin',
      flex: 1,
      child: [
        {
          title: '最高价',
          key: 'max',
          flex: 1
        },
        {
          title: '最低价',
          key: 'min',
          flex: 1
        }
      ]
    },
    {
      title: '操作人',
      key: 'lastOperator',
      flex: 1
    },
    {
      title: '操作时间',
      key: 'updatedTime',
      flex: 1
    },
    {
      title: '操作',
      key: 'operationInTable',
      flex: 1,
      width: '160px'
    }
  ]
  public loadingForFoodPriceModule = false
  // 列表内容有哪些：
  public foodPriceModuleBodyList: Array<any> = []
  // 列表每一行的操作有哪些：
  public columnOperationListForFoodPriceModulebodyList: Array<OperationItemType> = [
    {
      title: '修改',
      key: 'updateForFoodPriceModule',
      type: 'warning',
      size: 'mini'
    }
  ]
  // 新增或者修改食材的价格：
  public dialogFlagForFoodPrice: boolean = false
  public dialogTitleForFoodPrice: string = '新增食材价格'
  public optionsForFood: Array<OptionItemType> = []
  public foodName: string = ''
  public foodPriceMax: string = ''
  public foodPriceMin: string = ''
  public whoEditorId: string = ''

  get treeDataForDisposeNameSubject () {
    return CanteenModule.treeDataForDisposeNameSubject
  }

  async mounted () {
    const { paneName } = this.$route.query
    paneName && (this.paneName = paneName as string)
    await Promise.all([
      CanteenModule.getTreeDataForDisposeNameSubject()
    ])
    this.getFoodIngredient()
    this.getFoodPriceModuleBodyList()
  }

  // 获取食材（5001001下面的）：
  getFoodIngredient () {
    const foodIngredientItem = findItemForTree(this.treeDataForDisposeNameSubject, 'children', 'code', '5001001') as any
    this.optionsForFood = ((foodIngredientItem || { children: [] }).children || []).map(item => {
      return {
        name: item.name,
        value: item.code
      }
    })
  }

  // 获取食材价格管理列表：
  async getFoodPriceModuleBodyList () {
    try {
      this.loadingForFoodPriceModule = true
      const { data: result } = await (this as any).$http.adminListPriceUnit()
      this.loadingForFoodPriceModule = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.foodPriceModuleBodyList = (result.data || []).map(item => {
        return item
      })
    } catch (err) {
      console.log(err)
    }
  }

  // 操作按钮：
  operationForButton ({ key }, row) {
    const { id } = row
    switch (key) {
      case 'updateForFoodPriceModule':
        this.dialogFlagForFoodPrice = true
        this.dialogTitleForFoodPrice = '修改食材价格'
        this.foodName = row.subject
        this.foodPriceMax = row.max
        this.foodPriceMin = row.min
        this.whoEditorId = id
        break
    }
  }

  beforeLeave (activeName: string): void {
    this.$router.replace({ name: 'FoodPriceManagement', query: { paneName: activeName } })
    this.paneName = activeName
    this.getDateForWho()
  }

  getDateForWho () {
    switch (this.paneName) {
      case 'foodPriceModule':
        this.getFoodPriceModuleBodyList()
        break
    }
  }

  operationForDownload (): void {
    switch (this.paneName) {
      case 'foodPriceModule':
        this.loadingForFoodPriceModule = true
        const keysList = ['name', 'max', 'min', 'lastOperator', 'updatedTime']
        const dataRes = ((this as any).foodPriceModuleBodyList || []).map(v => {
          return keysList.map(vv => {
            let res = ''
            switch (vv) {
              default:
                res = v[vv]
            }
            return res
          })
        })
        import('../../plugins/xlsx/exportExcel').then(excel => {
          try {
            excel.export_json_to_excel({
              multiHeader: [
                ['食材名称', '市场价格区间', '市场价格区间', '操作人', '操作时间']
              ],
              header: ['', '最高价', '最低价', '', ''],
              autoWidth: true,
              data: dataRes,
              merges: ['A1:A2', 'B1:C1', 'D1:D2', 'E1:E2'],
              filename: '食材价格管理表.xlsx'
            })
            this.$message.success('食材价格管理表，导出成功')
          } catch (err) {
            console.log(err, 'err')
            this.$message.error('抱歉，导出失败')
          }
        })
        setTimeout(() => {
          this.loadingForFoodPriceModule = false
        }, 300)
        break
    }
  }

  operationForClickOfAddFoodPrice () {
    this.dialogFlagForFoodPrice = true
    this.dialogTitleForFoodPrice = '新增食材价格'
    this.foodName = this.foodPriceMax = this.foodPriceMin = this.whoEditorId = ''
  }

  // 保存食材价格管理：
  async operationForClickOfSaveFoodPrice () {
    try {
      if (!this.foodName) return this.$message.error('请选择食材名称')
      if (!this.foodPriceMax) return this.$message.error('请输入最高价')
      if (!this.foodPriceMin) return this.$message.error('请输入最低价')
      let params = {
        subject: this.foodName,
        max: this.foodPriceMax,
        min: this.foodPriceMin
      }
      let message = '食材价格新增成功'
      let api = 'adminAddPriceUnit'
      if (this.whoEditorId) {
        message = '食材价格编辑成功'
        api = 'adminUpdateByIdpriceUnit'
        Object.assign(params, { id: this.whoEditorId })
      }
      const { data: result } = await (this as any).$http[api](params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(message)
      this.dialogFlagForFoodPrice = false
      this.foodName = this.foodPriceMax = this.foodPriceMin = this.whoEditorId = ''
      this.getFoodPriceModuleBodyList()
    } catch (err) {
      console.log(err)
    }
  }
}
